import { Component, OnInit } from "@angular/core";
import { LoadingBarService } from "@ngx-loading-bar/core";
import { routeAppAnimation, slideInAnimation } from "./exports/animation";
import { ThemeService } from "./services/theme.service";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  animations: [slideInAnimation, routeAppAnimation],
  standalone: false,
  host: {
    class: "flex flex-col h-dvh w-full overflow-hidden",
  },
})
export class AppComponent implements OnInit {
  imgs = new Array();

  constructor(private _theme: ThemeService, public _ls: LoadingBarService) {}

  ngOnInit(): void {
    this._theme.checkActiveDarkTheme();
    if (localStorage.getItem("Equora_Theme")) {
      this._theme.addTheme(localStorage.getItem("Equora_Theme"));
    }
  }
}
